
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M9.5 1.5H4.333c-.46 0-.833.392-.833.875v12.25c0 .483.373.875.833.875h8.334c.46 0 .833-.392.833-.875V5.5m-4-4v4h4m-4-4 4 4m-6 7.5V8.5h1.591c.778 0 1.409.691 1.409 1.477 0 .785-.676 1.523-1.454 1.523H7.75"}})])
          )
        }
      }
    